import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_UPDATE_HOST_MEMO_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION = graphql(
	/* GraphQL */ `
		mutation ReservationDetailUpdateHostMemoForManagementReservationItemDetailUpdate(
			$input: ReservationDetailUpdateHostMemoInput!
		) {
			reservationDetailUpdateHostMemo(input: $input) {
				reservationDetail {
					memoByHost
				}
				userErrors
			}
		}
	`,
);
